import { useCreateMerchantContext } from 'Components/ManageMerchant/context';
import React from 'react';

import BankAccountList from './BankAccountList';

const BankAccounts = () => {
  const { merchant } = useCreateMerchantContext();

  return <div>{merchant && <BankAccountList merchant={merchant} />}</div>;
};

export default BankAccounts;
